import { AuthService } from '../services/AuthService';
import {
  type ICreateManagerRequest,
  type IManager,
  type IUpdateManagerRequest,
  type IUpdateManagerResponse,
  type IGetManagersRequest,
  type IGetManagersResponse,
  type IDeleteManagerResponse
} from '@/types/IManager';
import { CustomError, type IGenericResponseRoot } from '../utils/getErrorData';
import { api } from '../utils/api';

export const createManager = async (
  data: ICreateManagerRequest
): Promise<IGenericResponseRoot<IManager>> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.post<IGenericResponseRoot<IManager>>(
      `/admin/manager`,
      data,
      { headers }
    );

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при создании менеджера'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При создании менеджера произошла ошибка');
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

export const updateManager = async (
  managerUuid: string,
  data: IUpdateManagerRequest
): Promise<IGenericResponseRoot<IUpdateManagerResponse>> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.put<
      IGenericResponseRoot<IUpdateManagerResponse>
    >(`admin/manager/${managerUuid}`, data, { headers });

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при обновлении менеджера'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При обновлении менеджера произошла ошибка');
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

export const getManagers = async (
  params?: IGetManagersRequest
): Promise<IGenericResponseRoot<IGetManagersResponse>> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.get<IGenericResponseRoot<IGetManagersResponse>>(
      'admin/managers',
      {
        headers,
        params
      }
    );

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при получении списка менеджеров'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При получении списка менеджеров произошла ошибка');
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

export const deleteManager = async (
  managerUuid: string
): Promise<IGenericResponseRoot<IDeleteManagerResponse>> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.delete<
      IGenericResponseRoot<IDeleteManagerResponse>
    >(`admin/manager/${managerUuid}`, { headers });

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при удалении менеджера'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При удалении менеджера произошла ошибка');
    }

    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};
